import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { addCalcInfo } from 'CalculationsApp/ts/state/calc-info.actions';
import { setAxisExtremes } from 'ChartApp/ts/apps/scatter-plot/state/axis-extremes/axis-extremes.action';
import { setDataFormatAggregation, setDataFormatFillMethod, setDataFormatFrequency, } from 'ChartApp/ts/apps/scatter-plot/state/data-format/data-format.actions';
import { setEndDate } from 'ChartApp/ts/apps/scatter-plot/state/end-date/end-date.actions';
import { setLookback } from 'ChartApp/ts/apps/scatter-plot/state/lookback/lookback.actions';
import { setPlotType } from 'ChartApp/ts/apps/scatter-plot/state/plot-type/plot-type.actions';
import { setStartDate } from 'ChartApp/ts/apps/scatter-plot/state/start-date/start-date.actions';
import { setXAxisDate } from 'ChartApp/ts/apps/scatter-plot/state/x-axis-date/x-axis-date.actions';
import { setXAxisMetric } from 'ChartApp/ts/apps/scatter-plot/state/x-axis-metric/x-axis-metric.actions';
import { setYAxisDate } from 'ChartApp/ts/apps/scatter-plot/state/y-axis-date/y-axis-date.actions';
import { setYAxisMetric } from 'ChartApp/ts/apps/scatter-plot/state/y-axis-metric/y-axis-metric.actions';
import { getDataFormat, getEndDate, getLookback, getStartDate, getXAxisDate, getYAxisDate, } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { TIME_SERIES_AGGREGATION_DROPDOWN_OPTIONS, TIME_SERIES_FILL_METHOD_DROPDOWN_OPTIONS, TIME_SERIES_FREQUENCY_DROPDOWN_OPTIONS, } from 'Angular/constants/time-range-options.constants';
import { ALL_CALC, HISTORY_CALC } from 'CalculationsApp/ts/constants/calc-search-types.constants';
import { SCATTER_PLOT_SYSTEM_DEFAULT_STATE } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { ScatterPlotDateRangeType, ScatterPlotLookbackOptionXValues, ScatterPlotLookbackOptionYValues, ScatterPlotLookbackType, ScatterPlotPlotType, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
import { formatDateString } from 'Angular/utils/date';
import deepEqual from 'Angular/utils/equal/deep-equal';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/services/calculations.service";
import * as i2 from "@ngrx/store";
import * as i3 from "../../../../../../../../search/static/search/ts/features/autocomplete-in-place/metric-autocomplete-in-place/metric-autocomplete-in-place.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/date-range/date-range.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/full-year-date-range/full-year-date-range.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i12 from "../scatter-plot-securities-list/scatter-plot-securities-list.component";
const _c0 = a0 => ({ value: a0 });
const _c1 = () => ({ button: "btn btn-block btn-secondary", dropdownItem: "text-default" });
/**
 *
 * Scatter Plot Controls Component
 *
 * This component is the left sidebar on the scatter plot page that allows users to select securities, metrics, etc.
 *
 */
export class ScatterPlotControlsComponent {
    constructor(calculationsService, store) {
        this.calculationsService = calculationsService;
        this.store = store;
        this.closeHandler = new EventEmitter();
        this.defaultOnly = false;
        this.aggregationOptionsConfig = TIME_SERIES_AGGREGATION_DROPDOWN_OPTIONS;
        this.fillOptionsConfig = TIME_SERIES_FILL_METHOD_DROPDOWN_OPTIONS;
        this.frequencyOptionsConfig = TIME_SERIES_FREQUENCY_DROPDOWN_OPTIONS;
        // Constants
        this.DATE_AND_YEAR_OPTIONS = [
            { label: 'Date Range', value: ScatterPlotDateRangeType.date },
            { label: 'Full Year', value: ScatterPlotDateRangeType.year },
        ];
        this.PLOT_TYPE_OPTIONS = [
            { label: 'Point in Time', value: ScatterPlotPlotType.pointInTime },
            { label: 'Timeseries', value: ScatterPlotPlotType.timeseries },
        ];
        this.LOOKBACK_OPTIONS = {
            list: Object.values(ScatterPlotLookbackType).map((option) => {
                return { value: option, label: option };
            }),
        };
        this.DATE_OPTIONS = ScatterPlotDateRangeType;
        this.PLOT_TYPES = ScatterPlotPlotType;
        // Dates
        this.currentDate = new Date();
        this.currentYear = this.currentDate.getFullYear();
        this.searchType = ALL_CALC;
        this.dateRangeType = ScatterPlotDateRangeType.date;
        this.selectedDateRange = {
            startDate: null,
            endDate: null,
        };
        this.startDate = null;
        this.endDate = null;
        this.startYear = null;
        this.endYear = null;
        this.lookback = null;
        // Metrics
        this.xAxisMetric = '';
        this.yAxisMetric = '';
        this.fetchingXAxisMetric = false;
        this.fetchingYAxisMetric = false;
        /**
         * If xAxisDate and yAxisDate are selected than a new date object is created from a string otherwise the value is null.
         */
        this.mapStateToComponent = (state) => {
            this.plotType = state.scatterPlot.plotType;
            if (this.plotType === ScatterPlotPlotType.pointInTime)
                this.searchType = ALL_CALC;
            else if (this.plotType === ScatterPlotPlotType.timeseries)
                this.searchType = HISTORY_CALC;
            /*
             * Metrics can be added two ways: 1. User selects a result displayed by the autocompleter 2. User pastes a url
             * specifying a metric. `setMetric` is only called for case (1), and it updates NgRx store. Since we must
             * validate the metrics for both (1) and (2), we must validate metrics in `mapStateToComponent`.
             * */
            this.validateNextMetrics(state.calcInfo, state.scatterPlot.xAxisMetric, state.scatterPlot.yAxisMetric);
            this.xAxisMetric = state.scatterPlot.xAxisMetric;
            this.yAxisMetric = state.scatterPlot.yAxisMetric;
            const xAxisDate = getXAxisDate(state);
            const yAxisDate = getYAxisDate(state);
            this.xAxisDate = xAxisDate ? new Date(xAxisDate) : null;
            this.yAxisDate = yAxisDate ? new Date(yAxisDate) : null;
            const newStartDate = getStartDate(state);
            const newEndDate = getEndDate(state);
            if (newStartDate !== this.startDate || newEndDate !== this.endDate) {
                this.selectedDateRange = {
                    startDate: newStartDate ? new Date(newStartDate) : null,
                    endDate: newEndDate ? new Date(newEndDate) : null,
                };
            }
            this.startDate = newStartDate;
            this.endDate = newEndDate;
            // Check if the selected date range is in full years, meaning it begins and ends on the last day of a year
            if (this.selectedDateRange.startDate && this.selectedDateRange.endDate) {
                const lastMonth = 11;
                const lastDay = 31;
                const selectedDateRangeIsFullYear = this.selectedDateRange.startDate.getFullYear() !== this.selectedDateRange.endDate.getFullYear() &&
                    this.selectedDateRange.startDate.getMonth() === lastMonth &&
                    this.selectedDateRange.startDate.getDate() === lastDay &&
                    this.selectedDateRange.endDate.getMonth() === lastMonth &&
                    this.selectedDateRange.endDate.getDate() === lastDay;
                this.startYear = selectedDateRangeIsFullYear ? this.selectedDateRange.startDate.getFullYear() + 1 : null;
                if (selectedDateRangeIsFullYear && this.startYear !== this.selectedDateRange.endDate.getFullYear()) {
                    this.endYear = this.selectedDateRange.endDate.getFullYear();
                }
                else {
                    this.endYear = null;
                }
            }
            const dataFormat = getDataFormat(state);
            this.aggregation = dataFormat.aggregation;
            this.fillMethod = dataFormat.fillMethod;
            this.frequency = dataFormat.frequency;
            this.lookback = getLookback(state);
            // If the state is reset to the system default, use the lookback type to determine the xAxis and yAxis metrics and dates.
            if (deepEqual(state.scatterPlot, SCATTER_PLOT_SYSTEM_DEFAULT_STATE)) {
                this.lookbackChangeHandler(this.lookback);
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    get isCustomLookback() {
        return this.lookback === ScatterPlotLookbackType.custom;
    }
    /**
     * Reset the zoom when the user makes a change that might modify the axes.
     *
     * Note: This must be called **before** dispatching another action to update NgRx store.
     * The axisExtremes being updated is part of SCATTER_PLOT_PARAMS_NO_NEW_DATA, so changing its value will not
     * trigger a new backend request to be made. Another action must be dispatched after this one to trigger a request
     * that causes a new chart be drawn with the new axes.
     *
     * @param oldValue: The previous value of a scatter plot control option.
     * @param newValue: The new value of a scatter plot control option.
     */
    resetZoom(oldValue, newValue) {
        if (!deepEqual(oldValue, newValue)) {
            this.store.dispatch(setAxisExtremes({ axisExtremes: {} }));
            return true;
        }
        return false;
    }
    plotTypeHandler(newPlotType) {
        this.resetZoom(this.plotType, newPlotType);
        this.store.dispatch(setPlotType({ plotType: newPlotType }));
    }
    // Date Handlers
    dateRangeTypeHandler(dateRangeType) {
        this.resetZoom(this.dateRangeType, dateRangeType);
        this.dateRangeType = dateRangeType;
    }
    dateChangeHandler(dateObject, axis) {
        const date = dateObject ? formatDateString(dateObject) : null;
        if (axis === 'xAxis') {
            this.resetZoom(this.xAxisDate, date);
            this.store.dispatch(setXAxisDate({ date }));
        }
        else if (axis === 'yAxis') {
            this.resetZoom(this.yAxisDate, date);
            this.store.dispatch(setYAxisDate({ date }));
        }
    }
    setDateRange(dateRangeObject) {
        const startDate = dateRangeObject.startDate.date ? formatDateString(dateRangeObject.startDate.date) : null;
        const reset = this.resetZoom(startDate, dateRangeObject.startDate.date);
        this.store.dispatch(setStartDate({ date: startDate }));
        const endDate = dateRangeObject.endDate.date ? formatDateString(dateRangeObject.endDate.date) : null;
        if (!reset)
            this.resetZoom(endDate, dateRangeObject.endDate.date);
        this.store.dispatch(setEndDate({ date: endDate }));
    }
    aggregationChangeHandler(aggregation) {
        this.resetZoom(this.aggregation, aggregation);
        this.store.dispatch(setDataFormatAggregation({ aggregation }));
    }
    fillMethodDropdownHandler(fillMethod) {
        this.resetZoom(this.fillMethod, fillMethod);
        this.store.dispatch(setDataFormatFillMethod({ fillMethod }));
    }
    frequencyChangeHandler(frequency) {
        this.resetZoom(this.frequency, frequency);
        this.store.dispatch(setDataFormatFrequency({ frequency }));
    }
    startDateChanged(newDateRange) {
        const date = newDateRange.startDate ? formatDateString(newDateRange.startDate) : null;
        this.resetZoom(this.startDate, date);
        this.store.dispatch(setStartDate({ date }));
    }
    endDateChanged(newDateRange) {
        const date = newDateRange.endDate ? formatDateString(newDateRange.endDate) : null;
        this.resetZoom(this.endDate, date);
        this.store.dispatch(setEndDate({ date }));
    }
    lookbackChangeHandler(lookback) {
        // Default to five years if lookback is null.
        // Not done in the reducer because we need to respect what comes from the backend.
        // If the lookback is null, it means the user has not selected a lookback
        let newLookback = lookback;
        if (lookback === null) {
            newLookback = ScatterPlotLookbackType.fiveYears;
        }
        this.store.dispatch(setLookback({ lookback: newLookback }));
        switch (newLookback) {
            case ScatterPlotLookbackType.oneYear:
                this.setMetric('xAxis', ScatterPlotLookbackOptionXValues.oneYear);
                this.setMetric('yAxis', ScatterPlotLookbackOptionYValues.oneYear);
                this.dateChangeHandler(null, 'xAxis');
                this.dateChangeHandler(null, 'yAxis');
                break;
            case ScatterPlotLookbackType.threeYears:
                this.setMetric('xAxis', ScatterPlotLookbackOptionXValues.threeYears);
                this.setMetric('yAxis', ScatterPlotLookbackOptionYValues.threeYears);
                this.dateChangeHandler(null, 'xAxis');
                this.dateChangeHandler(null, 'yAxis');
                break;
            case ScatterPlotLookbackType.fiveYears:
                this.setMetric('xAxis', ScatterPlotLookbackOptionXValues.fiveYears);
                this.setMetric('yAxis', ScatterPlotLookbackOptionYValues.fiveYears);
                this.dateChangeHandler(null, 'xAxis');
                this.dateChangeHandler(null, 'yAxis');
                break;
            case ScatterPlotLookbackType.tenYears:
                this.setMetric('xAxis', ScatterPlotLookbackOptionXValues.tenYears);
                this.setMetric('yAxis', ScatterPlotLookbackOptionYValues.tenYears);
                this.dateChangeHandler(null, 'xAxis');
                this.dateChangeHandler(null, 'yAxis');
                break;
            default:
            // do nothing for custom lookback
        }
    }
    // Metric Handlers
    /**
     * Depending on which axis the user selects a metric for, use the result returned by the autocompleter to update
     * the appropriate axis's metric.
     *
     * See `mapStateToComponent` for why we don't validate metrics in this function.
     *
     * @param axis: The axis whose metric is being set.
     * @param metricId: A string unique to the metric. This can be AutocompleteResult.search_id or Metric.internal_name
     */
    setMetric(axis, metricId) {
        if (axis === 'xAxis') {
            this.resetZoom(this.xAxisMetric, metricId);
            this.store.dispatch(setXAxisMetric({ metricId }));
        }
        else if (axis === 'yAxis') {
            this.resetZoom(this.yAxisMetric, metricId);
            this.store.dispatch(setYAxisMetric({ metricId }));
        }
    }
    /**
     * Validate xAxisMetric and yAxisMetric.
     *
     * @param calcInfo: An object containing information about the metric.
     * @param xAxisMetric: The string id of the x axis metric.
     * @param yAxisMetric: The string id of the y axis metric.
     */
    validateNextMetrics(calcInfo, xAxisMetric, yAxisMetric) {
        // If an xAxisMetric was selected, check if we have info about it to display.
        // If we don't have info yet, fetch it. If successfully fetched, validate the metric
        if (xAxisMetric && xAxisMetric !== this.xAxisMetric) {
            let xAxisCalcInfo = {};
            if (!calcInfo[xAxisMetric] && !this.fetchingXAxisMetric) {
                this.fetchingXAxisMetric = true;
                this.calculationsService.getCalcInfo([xAxisMetric]).subscribe((response) => {
                    xAxisCalcInfo = response;
                    this.store.dispatch(addCalcInfo({ calcInfo: xAxisCalcInfo }));
                    if (!xAxisCalcInfo[xAxisMetric]) {
                        this.store.dispatch(setXAxisMetric({ metricId: '' }));
                    }
                    this.fetchingXAxisMetric = false;
                });
            }
        }
        // If a yAxisMetric was selected, check if we have info about it to display.
        // If we don't have info yet, fetch it. If successfully fetched, validate the metric
        if (yAxisMetric && yAxisMetric !== this.yAxisMetric) {
            let yAxisCalcInfo = {};
            if (!calcInfo[yAxisMetric] && !this.fetchingYAxisMetric) {
                this.fetchingYAxisMetric = true;
                this.calculationsService.getCalcInfo([yAxisMetric]).subscribe((response) => {
                    yAxisCalcInfo = response;
                    this.store.dispatch(addCalcInfo({ calcInfo: yAxisCalcInfo }));
                    if (!yAxisCalcInfo[yAxisMetric]) {
                        this.store.dispatch(setYAxisMetric({ metricId: '' }));
                    }
                    this.fetchingYAxisMetric = false;
                });
            }
        }
    }
}
ScatterPlotControlsComponent.ɵfac = function ScatterPlotControlsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotControlsComponent)(i0.ɵɵdirectiveInject(i1.CalculationsService), i0.ɵɵdirectiveInject(i2.Store)); };
ScatterPlotControlsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotControlsComponent, selectors: [["ycn-scatter-plot-controls"]], inputs: { defaultOnly: "defaultOnly" }, outputs: { closeHandler: "closeHandler" }, standalone: false, decls: 72, vars: 57, consts: [["helpModal", ""], [1, "panel-sidebar-wrap"], [1, "panel-sidebar", "bg-panel", "panel-sidebar-scroll", "user-select-none"], ["ycnTooltip", "", "data-test-id", "close-handler", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "panel-sidebar-toggler", "panel-sidebar-toggler-close", 3, "click", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "panel-sidebar-section"], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title"], ["data-test-id", "scatter-plot-type-help", 1, "help-toggler", 3, "click"], [1, "custom-controls-stacked", 3, "selectHandler", "groupName", "options", "selectedObject"], [1, "panel-sidebar-section", 3, "hidden"], ["data-test-id", "scatter_plot_point_in_time_help", 1, "help-toggler", 3, "click"], [1, "panel-sidebar-section-body"], [1, "mb-1"], ["data-test-id", "scatter-plot-lookback-dropdown", 3, "changeHandler", "config", "selectedValue"], ["data-test-id", "scatter-plot-x-axis-date-picker-section", 1, "panel-sidebar-section", 3, "hidden"], ["data-test-id", "scatter-plot-x-axis-help", 1, "help-toggler", 3, "click"], [1, "field-search-browse-wrap", 3, "submitHandler", "submitModalHandler", "appendToBody", "displayIdentifier", "editShowDialog", "hideCancelButton", "searchType", "tooltipText", "defaultOnly"], [1, "form-group", "dropdown", "mb-1"], [3, "dateChangeHandler", "hidden", "selectedDate"], ["data-test-id", "scatter-plot-y-axis-help", 1, "help-toggler", 3, "click"], ["data-test-id", "scatter-plot-time-range-and-options-help", 1, "help-toggler", 3, "click"], [1, "panel-sidebar-section-row", "form-row"], [3, "selectHandler", "groupName", "options", "selectedObject"], [1, "form-row", 3, "hidden"], [1, "data-range-cover", "form-inline", "input-group"], [1, "inputs-wrap", 3, "startDateChangeHandler", "endDateChangeHandler", "startYear", "endYear", "selectedDateRange"], [1, "inputs-wrap", "dropdown", 3, "dateRangeHandler", "startYear", "endYear"], [1, "form-row"], [1, "form-label", "form-label-thin"], [3, "changeHandler", "config", "customCssClasses", "selectedValue"], [3, "changeHandler", "config", "customCssClasses", "inputDisabled", "selectedValue"]], template: function ScatterPlotControlsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeHandler.emit()); });
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(4, "svg", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(5, "ycn-scatter-plot-securities-list");
        i0.ɵɵelementStart(6, "section", 5)(7, "div", 6)(8, "div", 7);
        i0.ɵɵtext(9, " Scatter Plot Type ");
        i0.ɵɵelementStart(10, "span", 8);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_span_click_10_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(71); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_type")); });
        i0.ɵɵtext(11, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(12, "ycn-radio-button-group", 9);
        i0.ɵɵlistener("selectHandler", function ScatterPlotControlsComponent_Template_ycn_radio_button_group_selectHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.plotTypeHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "section", 10)(14, "div", 6)(15, "div", 7);
        i0.ɵɵtext(16, " Point in Time ");
        i0.ɵɵelementStart(17, "span", 11);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_span_click_17_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(71); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_point_in_time")); });
        i0.ɵɵtext(18, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(19, "div", 12)(20, "div", 13)(21, "ycn-single-select-dropdown", 14);
        i0.ɵɵlistener("changeHandler", function ScatterPlotControlsComponent_Template_ycn_single_select_dropdown_changeHandler_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.lookbackChangeHandler($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(22, "section", 15)(23, "div", 6)(24, "div", 7);
        i0.ɵɵtext(25, " X-Axis ");
        i0.ɵɵelementStart(26, "span", 16);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_span_click_26_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(71); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_x_axis")); });
        i0.ɵɵtext(27, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(28, "div", 12)(29, "div", 13)(30, "ycn-metric-autocomplete-in-place", 17);
        i0.ɵɵlistener("submitHandler", function ScatterPlotControlsComponent_Template_ycn_metric_autocomplete_in_place_submitHandler_30_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setMetric("xAxis", $event.search_id)); })("submitModalHandler", function ScatterPlotControlsComponent_Template_ycn_metric_autocomplete_in_place_submitModalHandler_30_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setMetric("xAxis", $event.internal_name)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "div", 18)(32, "ycn-single-date-picker", 19);
        i0.ɵɵlistener("dateChangeHandler", function ScatterPlotControlsComponent_Template_ycn_single_date_picker_dateChangeHandler_32_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event, "xAxis")); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(33, "section", 10)(34, "div", 6)(35, "div", 7);
        i0.ɵɵtext(36, " Y-Axis ");
        i0.ɵɵelementStart(37, "span", 20);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_span_click_37_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(71); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_y_axis")); });
        i0.ɵɵtext(38, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(39, "div", 12)(40, "div", 13)(41, "ycn-metric-autocomplete-in-place", 17);
        i0.ɵɵlistener("submitHandler", function ScatterPlotControlsComponent_Template_ycn_metric_autocomplete_in_place_submitHandler_41_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setMetric("yAxis", $event.search_id)); })("submitModalHandler", function ScatterPlotControlsComponent_Template_ycn_metric_autocomplete_in_place_submitModalHandler_41_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setMetric("yAxis", $event.internal_name)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(42, "div", 18)(43, "ycn-single-date-picker", 19);
        i0.ɵɵlistener("dateChangeHandler", function ScatterPlotControlsComponent_Template_ycn_single_date_picker_dateChangeHandler_43_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event, "yAxis")); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(44, "section", 10)(45, "div", 6)(46, "div", 7);
        i0.ɵɵtext(47, " Time Range & Options ");
        i0.ɵɵelementStart(48, "span", 21);
        i0.ɵɵlistener("click", function ScatterPlotControlsComponent_Template_span_click_48_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(71); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_time_range_and_options")); });
        i0.ɵɵtext(49, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(50, "div", 12)(51, "div", 22)(52, "ycn-radio-button-group", 23);
        i0.ɵɵlistener("selectHandler", function ScatterPlotControlsComponent_Template_ycn_radio_button_group_selectHandler_52_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateRangeTypeHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(53, "div", 24)(54, "div", 25)(55, "ycn-date-range", 26);
        i0.ɵɵlistener("startDateChangeHandler", function ScatterPlotControlsComponent_Template_ycn_date_range_startDateChangeHandler_55_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.startDateChanged($event)); })("endDateChangeHandler", function ScatterPlotControlsComponent_Template_ycn_date_range_endDateChangeHandler_55_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.endDateChanged($event)); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(56, "div", 24)(57, "ycn-full-year-date-range", 27);
        i0.ɵɵlistener("dateRangeHandler", function ScatterPlotControlsComponent_Template_ycn_full_year_date_range_dateRangeHandler_57_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setDateRange($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(58, "div", 28)(59, "div", 29);
        i0.ɵɵtext(60, "Frequency");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "ycn-single-select-dropdown", 30);
        i0.ɵɵlistener("changeHandler", function ScatterPlotControlsComponent_Template_ycn_single_select_dropdown_changeHandler_61_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.frequencyChangeHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(62, "div", 28)(63, "div", 29);
        i0.ɵɵtext(64, "Aggregation");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "ycn-single-select-dropdown", 31);
        i0.ɵɵlistener("changeHandler", function ScatterPlotControlsComponent_Template_ycn_single_select_dropdown_changeHandler_65_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.aggregationChangeHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(66, "div", 28)(67, "div", 29);
        i0.ɵɵtext(68, "Fill Method");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(69, "ycn-single-select-dropdown", 31);
        i0.ɵɵlistener("changeHandler", function ScatterPlotControlsComponent_Template_ycn_single_select_dropdown_changeHandler_69_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.fillMethodDropdownHandler($event)); });
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelement(70, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipTitle", "Hide Controls");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-close-arrow");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("groupName", "plotTypeRadioButtonGroup")("options", ctx.PLOT_TYPE_OPTIONS)("selectedObject", i0.ɵɵpureFunction1(50, _c0, ctx.plotType));
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.plotType !== ctx.PLOT_TYPES.pointInTime);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("config", ctx.LOOKBACK_OPTIONS)("selectedValue", ctx.lookback);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.isCustomLookback && ctx.plotType == ctx.PLOT_TYPES.pointInTime);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("appendToBody", true)("displayIdentifier", ctx.xAxisMetric)("editShowDialog", true)("hideCancelButton", true)("searchType", ctx.searchType)("tooltipText", "Edit Metric")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.plotType !== ctx.PLOT_TYPES.pointInTime)("selectedDate", ctx.xAxisDate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.isCustomLookback && ctx.plotType == ctx.PLOT_TYPES.pointInTime);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("appendToBody", true)("displayIdentifier", ctx.yAxisMetric)("editShowDialog", true)("hideCancelButton", true)("searchType", ctx.searchType)("tooltipText", "Edit Metric")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.plotType !== ctx.PLOT_TYPES.pointInTime)("selectedDate", ctx.yAxisDate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.plotType !== ctx.PLOT_TYPES.timeseries);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("groupName", "dateRangeRadioButtonGroup")("options", ctx.DATE_AND_YEAR_OPTIONS)("selectedObject", i0.ɵɵpureFunction1(52, _c0, ctx.dateRangeType));
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.dateRangeType !== ctx.DATE_OPTIONS.date);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("startYear", 1890)("endYear", ctx.currentYear)("selectedDateRange", ctx.selectedDateRange);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.dateRangeType !== ctx.DATE_OPTIONS.year);
        i0.ɵɵadvance();
        i0.ɵɵproperty("startYear", ctx.startYear)("endYear", ctx.endYear);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.frequencyOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(54, _c1))("selectedValue", ctx.frequency);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.aggregationOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(55, _c1))("inputDisabled", !ctx.frequency)("selectedValue", ctx.aggregation);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.fillOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(56, _c1))("inputDisabled", !ctx.frequency)("selectedValue", ctx.fillMethod);
    } }, dependencies: [i3.MetricAutocompleteInPlaceComponent, i4.DateRangeComponent, i5.FullYearDateRangeComponent, i6.HelpModalComponent, i7.IconDirective, i8.RadioButtonGroupComponent, i9.SingleDatePickerComponent, i10.SingleSelectDropdownComponent, i11.TooltipDirective, i12.ScatterPlotSecuritiesListComponent], encapsulation: 2 });
